const apiUrl = process.env.REACT_APP_API_URL;

export const addSupplies = async (data) => {
    const token = sessionStorage.getItem('token');

    const res = await fetch(`${apiUrl}/api/items/addSupplies`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });

    const body = await res.json().catch(() => ({}));

    if (!res.ok) {
        return { result: false, message: body?.message || 'No se pudo guardar el consumible.' };
    }

    return body;
};

export const updateSupply = async (id, data) => {
    console.log('Actualizando consumible con ID:', id, 'Datos:', data);
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/updateSupply/${id}`;

    const res = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(data),
    });

    const body = await res.json().catch(() => ({}));

    if (!res.ok) {
        return { result: false, message: body?.message || 'No se pudo actualizar el consumible.' };
    }
    return body;
};

export const deleteSupply = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/supplies/${id}`;
    const res = await fetch(url, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return null;
    return await res.json();
};

export const getSupplies = async () => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/supplies`;
    const res = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return null;
    return await res.json();
};

export const getSupplyById = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/supplies/${id}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });

    const body = await res.json().catch(() => ({}));

    if (!res.ok) {
        return { result: false, message: body?.message || `No se pudo cargar (status ${res.status}).` };
    }

    return { result: true, data: body };
};

//-------------------Supplies Reports-------------------
const postJSON = async (url, body) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body || {}),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) throw new Error(data?.message || `Request failed (${res.status})`);
    return data;
};

export const getSuppliesReport = async ({ page = 1, pageSize = 10, q = '', status = 'all' } = {}) =>
    postJSON(`${apiUrl}/api/items/supplies/reports/list`, { page, pageSize, q, status });

export const getSuppliesReportTotals = async ({ q = '', status = 'all' } = {}) =>
    postJSON(`${apiUrl}/api/items/supplies/reports/totals`, { q, status });

export const getSuppliesReportFull = async ({ q = '', status = 'all' } = {}) =>
    postJSON(`${apiUrl}/api/items/supplies/reports/full`, { q, status });